import React, { useContext } from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { UIContext } from '../context/UIContext';

const ColourDisplay = ({
  name,
  colour,
  renderBorder,
}: {
  name: string;
  colour: string;
  renderBorder?: boolean;
}) => {
  const { colorMode } = useContext(UIContext);
  let borderStyling: SxProps<Theme> = {};
  if (renderBorder)
    borderStyling = {
      border: '1px solid',
      borderColor: colorMode === 'light' ? 'grey.18p' : 'grey.87p',
    };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        width: '100%',
      }}
    >
      <Box
        component="span"
        sx={{
          height: '20px',
          width: '20px',
          minWidth: '20px',
          backgroundColor: `${colour}`,
          display: 'inline-flex',
          borderRadius: '50%',
          ...borderStyling,
        }}
      />
      <Typography
        variant="body2"
        sx={{ ml: '10px', verticalAlign: 'middle', textOverflow: 'ellipsis', overflow: 'hidden' }}
      >
        {name}
      </Typography>
    </Box>
  );
};

export default ColourDisplay;
